import React from 'react';

const Faq = () => {

    return (
        <div>
            <h2 className="text-center mt-3">This is FAQ page</h2>
        </div>
    );
};

export default Faq;